import { Component } from 'react'
import WrapperPageSimple from '../../WrapperPage/present/WrapperPageSimple'
import Translation from '../../Translation/cont/Translation'
import PreviewMoviesListItem from './PreviewMoviesListItem'
import DialogCreatePreviewMovie from './DialogCreatePreviewMovie'
import RequestOverlayContainer from '../../overlay/container/RequestOverlayContainer'
import SearchInput from '../../general/SearchInput'
import TargetPickerModal from '../../PageMetaMapping/present/TargetPickerModal'
import sortCinemas from '../../../functions/sortCinemas'
import { toStartingDateString } from '../../../functions/pmStartingDate'

// The movie's effective start date as the day the list and the popup show.
// Until the next sync cliMovies can hold a Date or a pm timestamp from the
// movie edit form; both become their day here.
const startingDayOf = (cliMovies, metaMoviePk, timezone) => toStartingDateString(
    cliMovies && cliMovies[metaMoviePk] ? cliMovies[metaMoviePk].startingDate : null,
    timezone
)

class PagePreviewMoviesPage extends Component {
    constructor(props) {
        super(props)
        this.state = { searchQuery: '', showCreateDialog: false, ksConnectPk: null }
    }

    render() {
        const {
            items, cinemas, clientCinemaId, movieMappings, tmdbMovies, cliMovies, timezone,
            pyMovies, khMovies, compesoMovies, dieselMovies, cortecMovies, marsxMovies, vistaMovies,
            onDelete, onCreateEdit, onCreateTmdb, onMerge, goBackPath, onEdit,
        } = this.props
        const { searchQuery, showCreateDialog, ksConnectPk } = this.state
        const providerMoviesProps = { pyMovies, khMovies, compesoMovies, dieselMovies, cortecMovies, marsxMovies, vistaMovies }
        const allCinemaIds = sortCinemas(clientCinemaId, cinemas) || []

        const itemList = items
            ? Object.values(items).filter(item =>
                !searchQuery || (item.title && item.title.toLowerCase().includes(searchQuery.toLowerCase()))
              )
            : []

        return (
            <WrapperPageSimple pageTitleTransId="route_preview_movies" overlay={<RequestOverlayContainer />} closePagePath={goBackPath}>
                <div className="preview-movies-page">
                    <div className="preview-movies-toolbar">
                        <div className="toolbar-add">
                            <button className="button" onClick={() => this.setState({ showCreateDialog: true })}>
                                + <Translation id="preview_movies_new_button" />
                            </button>
                        </div>
                        <div className="toolbar-search">
                            <SearchInput
                                placeholderTransId="social_media_search_movie_placeholder"
                                value={searchQuery}
                                onChange={val => this.setState({ searchQuery: val })}
                                width={300}
                            />
                        </div>
                    </div>

                    <div className="preview-movies-list-header text-light-uppercase">
                        <div />
                        <div><Translation id="preview_movies_col_film" /></div>
                        <div><Translation id="preview_movies_col_startdate" /></div>
                        <div>TMDB</div>
                        <div><Translation id="source_ks" /></div>
                    </div>

                    <ul className="preview-movies-list">
                        {itemList.map((item, index) => (
                            <PreviewMoviesListItem
                                key={item.metaMoviePk}
                                item={item}
                                startingDate={startingDayOf(cliMovies, item.metaMoviePk, timezone)}
                                cinemas={cinemas}
                                allCinemaIds={allCinemaIds}
                                movieMappings={movieMappings}
                                tmdbMovies={tmdbMovies}
                                index={index}
                                onDelete={onDelete}
                                onEdit={onEdit}
                                onKsConnect={(metaMoviePk) => this.setState({ ksConnectPk: metaMoviePk })}
                            />
                        ))}
                    </ul>
                </div>

                {showCreateDialog && (
                    <DialogCreatePreviewMovie
                        cinemas={cinemas}
                        cliCinemasIdList={allCinemaIds}
                        onCreateEdit={data => { this.setState({ showCreateDialog: false }); onCreateEdit(data) }}
                        onCreateTmdb={data => { this.setState({ showCreateDialog: false }); onCreateTmdb(data) }}
                        onClose={() => this.setState({ showCreateDialog: false })}
                    />
                )}

                {ksConnectPk && (
                    <TargetPickerModal
                        type="merge"
                        movieMappings={movieMappings}
                        cinemas={cinemas}
                        providerMoviesProps={providerMoviesProps}
                        pmPreviewMovies={items}
                        excludePk={ksConnectPk}
                        onConfirm={(destinationPk, sourcePk) => {
                            onMerge(sourcePk !== undefined ? sourcePk : ksConnectPk, destinationPk)
                            this.setState({ ksConnectPk: null })
                        }}
                        onCancel={() => this.setState({ ksConnectPk: null })}
                    />
                )}
            </WrapperPageSimple>
        )
    }
}

export default PagePreviewMoviesPage
